import React from 'react';
import { GlassCard } from '../components/GlassCard';
import { BellIcon, ShieldIcon, CreditCardIcon, HelpCircleIcon, LogOutIcon, ChevronRightIcon } from 'lucide-react';
export function Settings() {
  const settingsSections = [{
    id: 'notifications',
    title: 'Notifications',
    icon: <BellIcon size={20} className="text-blue-500" data-id="element-199" />,
    description: 'Manage your notification preferences'
  }, {
    id: 'privacy',
    title: 'Privacy & Security',
    icon: <ShieldIcon size={20} className="text-blue-500" data-id="element-200" />,
    description: 'Control your data and privacy settings'
  }, {
    id: 'payment',
    title: 'Payment Methods',
    icon: <CreditCardIcon size={20} className="text-blue-500" data-id="element-201" />,
    description: 'Add or manage your payment options'
  }, {
    id: 'help',
    title: 'Help & Support',
    icon: <HelpCircleIcon size={20} className="text-blue-500" data-id="element-202" />,
    description: 'Get assistance with AURA'
  }];
  return <div className="space-y-5 pb-4 pt-4 px-4" data-id="element-203">
      <h1 className="text-xl font-bold text-gray-900" data-id="element-204">Settings</h1>
      {/* Account info summary - consistent padding */}
      <GlassCard className="bg-gradient-to-r from-blue-50 to-white/90 p-4" data-id="element-205">
        <div className="flex flex-col" data-id="element-206">
          <span className="text-blue-500 text-sm font-medium" data-id="element-207">Account</span>
          <span className="text-lg font-bold text-gray-900 mt-1" data-id="element-208">Finn</span>
          <span className="text-sm text-gray-500" data-id="element-209">finn@example.com</span>
        </div>
      </GlassCard>
      {/* Settings sections - consistent spacing */}
      <div className="space-y-3" data-id="element-210">
        {settingsSections.map(section => <GlassCard key={section.id} className="hover:bg-white/80 transition-colors p-4" data-id="element-211">
            <button className="w-full flex items-center justify-between" data-id="element-212">
              <div className="flex items-center" data-id="element-213">
                <div className="mr-4" data-id="element-214">{section.icon}</div>
                <div className="text-left" data-id="element-215">
                  <h3 className="font-medium text-gray-900" data-id="element-216">{section.title}</h3>
                  <p className="text-xs text-gray-500 mt-0.5" data-id="element-217">
                    {section.description}
                  </p>
                </div>
              </div>
              <ChevronRightIcon size={18} className="text-gray-400" data-id="element-218" />
            </button>
          </GlassCard>)}
      </div>
      {/* App info - consistent spacing */}
      <div className="space-y-4 mt-6 px-4" data-id="element-219">
        <div data-id="element-220">
          <div className="text-xs text-gray-500" data-id="element-221">App Version</div>
          <div className="text-sm text-gray-700" data-id="element-222">AURA v1.2.4</div>
        </div>
        <button className="flex items-center text-red-500" data-id="element-223">
          <LogOutIcon size={16} className="mr-2" data-id="element-224" />
          <span className="text-sm font-medium" data-id="element-225">Log Out</span>
        </button>
      </div>
    </div>;
}